import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpApiService } from '../http.api.service';
import { EfateCakeDataSet } from '../../models/echo/efate-cake-data-set';

@Injectable({
  providedIn: 'root'
})
export class EfateCakeDatasetApiService extends HttpApiService {
  override apiUrl: string = environment.BAMS_Api_URL;

  getEfateCakeDataSetsBySetupPk(efateSetupPk: number): Observable<EfateCakeDataSet[]> {
    const endpoint = `api/efate/cakeDataSet/${efateSetupPk}`;
    return this.get(endpoint).pipe(map((data: any) => data?.Value ?? data));
  }

  saveEfateCakeDataSet(pObject: any): Observable<any> {
    const body = JSON.stringify(pObject);
    const headers = new HttpHeaders({ 'Content-type': 'application/json' });
    const endpoint = 'api/efate/cakeDataSet';
    return this.put(endpoint, body, headers)
      .pipe(map((data: any) => data?.Value ?? data));
  }
}
